import React, { ReactElement } from 'react';
import cn from 'classnames';

import type { Analytics } from 'services/analytics';

import './categorizerHeadingRow.scss';

interface Props {
    isActive?: boolean;
    prefix?: ReactElement;
    suffix?: ReactElement;
    onClick?: VoidFn;
    analytics?: Analytics;
}

const CategorizerHeadingRow: React.FC<Props> = ({
    isActive = false,
    prefix,
    suffix,
    onClick,
    children,
    analytics,
}) => {
    return (
        <div
            styleName={cn('container', {
                'is-active': isActive,
            })}
            className="__app-CategorizerHeadingRow-container"
            data-category={analytics?.category}
            data-action={analytics?.action}
            onClick={onClick}
        >
            {prefix && (
                <div
                    styleName="prefix"
                    className="__app-CategorizerHeadingRow-prefix"
                >
                    {prefix}
                </div>
            )}
            {children && (
                <div
                    styleName="body"
                    className="__app-CategorizerHeadingRow-body"
                >
                    {children}
                </div>
            )}
            {suffix && (
                <div
                    styleName="suffix"
                    className="__app-CategorizerHeadingRow-suffix"
                >
                    {suffix}
                </div>
            )}
        </div>
    );
};

export default CategorizerHeadingRow;
